import React from 'react';
import {
  Users, Image, Mail, BookOpen, TreePine, Camera, User, Landmark, Settings,
  PartyPopper, Cake, Home, MoreHorizontal, LogOut, ArrowLeft, HelpCircle,
  ImagePlus, Music, Video, Phone, Eye, Pen, Crown,
  FileText, Activity, Paintbrush, MessageCircle, Pin, UsersRound,
  Lock, Globe, Tree, FolderOpen, Search, Volume2, Link2, Lightbulb,
  Bug, ChevronDown, ChevronUp, CircleDot,
  Send, Inbox, Sun, Moon, Monitor, UserCog, Palette, GitBranch,
  ArrowDown, ArrowUp, CircleUser, ShieldCheck, Footprints,
} from 'lucide-react';

/**
 * Maps icon key strings to Lucide React components.
 * Use AppIcon instead of emoji icons throughout the app.
 */
const ICON_MAP = {
  // Navigation
  'home': Home,
  'tree': TreePine,
  'users': Users,
  'image': Image,
  'book': BookOpen,
  'mail': Mail,
  'settings': Settings,
  'more': MoreHorizontal,
  'help': HelpCircle,
  'logout': LogOut,
  'back': ArrowLeft,

  // Dashboard
  'family-members': Users,
  'memories': Image,
  'invitations': Mail,
  'kinship': BookOpen,
  'family-tree': TreePine,
  'add-memory': Camera,
  'invite-family': Mail,
  'members': User,
  'cultural': Landmark,
  'welcome': PartyPopper,
  'cake': Cake,

  // Memory types
  'photo': Image,
  'story': BookOpen,
  'audio': Music,
  'video': Video,
  'folder': FolderOpen,
  'image-plus': ImagePlus,

  // Invitation
  'email': Mail,
  'phone': Phone,
  'viewer': Eye,
  'contributor': Pen,
  'admin': Crown,
  'send': Send,
  'inbox': Inbox,

  // Cultural
  'noun': FileText,
  'verb': Footprints,
  'adjective': Paintbrush,
  'phrase': MessageCircle,
  'other': Pin,
  'maternal': CircleUser,
  'paternal': CircleUser,
  'both': UsersRound,
  'pronunciation': Volume2,
  'cultural-notes': FileText,
  'examples': MessageCircle,
  'related': Link2,
  'has-audio': Volume2,

  // Member
  'overview': User,
  'family': UsersRound,
  'edit': Pen,
  'camera': Camera,
  'parents': Users,

  // Settings
  'account': UserCog,
  'family-settings': UsersRound,
  'appearance': Palette,
  'light': Sun,
  'dark': Moon,
  'auto': Monitor,

  // Tree view modes
  'descendant': ArrowDown,
  'pedigree': ArrowUp,
  'fan': CircleDot,

  // About
  'privacy': Lock,
  'globe': Globe,
  'terms': FileText,
  'bug': Bug,
  'lightbulb': Lightbulb,
  'shield': ShieldCheck,

  // Misc
  'search': Search,
  'export': Inbox,
  'loader': Activity,
  'sparkles': PartyPopper,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'tree-view': GitBranch,
};

/**
 * AppIcon renders a Lucide icon by key string.
 * Falls back to CircleDot if key not found.
 */
function AppIcon({ name, size = 20, className = '', ...props }) {
  const IconComponent = ICON_MAP[name];
  if (!IconComponent) {
    return <CircleDot size={size} className={`text-gray-400 ${className}`} {...props} />;
  }
  return <IconComponent size={size} className={className} {...props} />;
}

export { ICON_MAP, AppIcon };
export default AppIcon;